import React from "react";

export default function AppLoading() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "#f9fafb",
        zIndex: 99999,
        fontFamily: "'Rubik', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 24,
      }}
    >
      <style>{`
        @keyframes v-al-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.72; }
        }
        @keyframes v-al-dot-1 { 0%,20%{ opacity:0 } 30%,80%{ opacity:1 } 100%{ opacity:0 } }
        @keyframes v-al-dot-2 { 0%,40%{ opacity:0 } 50%,90%{ opacity:1 } 100%{ opacity:0 } }
        @keyframes v-al-dot-3 { 0%,60%{ opacity:0 } 70%,100%{ opacity:1 } }
      `}</style>

      {/* Logo — fixed size, vertically centered above text */}
      <div
        style={{
          width: 72,
          height: 62,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "v-al-pulse 2.8s ease-in-out infinite",
        }}
      >
        <svg
          viewBox="0 0 111.5 95"
          width={72}
          height={62}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#2FBF71"
            d="M48.1,91.7C-5.2,54.5,18,30.4,54.1,29C70.5,28.3,71,1.3,53.5,3.5C36.2,5.7-1,20.2,5.8,46.7C11.1,66.8,35.7,87.2,48.1,91.7z"
          />
          <path
            fill="#4C75AB"
            d="M63.4,3.3c53.3,37.1,30.1,61.2-6,62.7c-16.3,0.7-16.8,27.7,0.6,25.5c17.2-2.2,54.5-16.8,47.7-43.2C100.5,28.1,75.8,7.8,63.4,3.3z"
          />
          <circle cx="55.8" cy="47.5" r="6.5" fill="#4C75AB" />
        </svg>
      </div>

      {/* "Loading..." text — centered below logo */}
      <span
        style={{
          color: "#6b7280",
          fontSize: 14,
          display: "flex",
          alignItems: "baseline",
          justifyContent: "center",
        }}
      >
        Loading
        <span style={{ display: "inline-flex", width: "1.2em", marginLeft: 1 }}>
          <span style={{ animation: "v-al-dot-1 1.6s infinite", opacity: 0 }}>.</span>
          <span style={{ animation: "v-al-dot-2 1.6s infinite", opacity: 0 }}>.</span>
          <span style={{ animation: "v-al-dot-3 1.6s infinite", opacity: 0 }}>.</span>
        </span>
      </span>
    </div>
  );
}
